import ComingSoon from "./ComingSoon";

const Mpesa = () => <ComingSoon />;

export default Mpesa;
